import canHaveTargetMedia from 'utils/canHaveTargetMedia'

export default function collectMediaForTargetsIds({ state }) {
  const basketItems = state.get('basket.basketItems')
  const ids = Object.keys(basketItems).reduce((acc, item) => {
    const { name, orderItemId } = basketItems[item]
    if (canHaveTargetMedia(name)) {
      acc.push(`"${orderItemId}"`)
    }

    return acc
  }, [])

  return { ids }
}



// WEBPACK FOOTER //
// ./src/modules/Basket/actions/collectMediaForBasket.js